<script lang="ts">
    import src from './svg/more_vert_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateRoundIcon from './TemplateRoundIcon.svelte';
    import WhiteColor from '../WhiteColor.svelte';
    export let scale: number = 1;
    let backgroundColor = '#313131';
    let style = 'filter: invert(1); transform: translateX(10px);';
</script>

<div style="transform: rotate(90deg);" class="icon-more-vert-rounded">
    <TemplateRoundIcon {src} {scale} alt="Menu" on:click {backgroundColor} {style} />
</div>

<style>
    .icon-more-vert-rounded :global(img) {
        transform: translateX(3px) scale(0.7) !important;
    }
</style>
